import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const timeCheckSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({        
        getKronosTimeReasonableness: builder.query({
            query: (arg: any) => {
                const { year, month } = arg;
                return {
                    url: constants.KRONOS_TIME_REASONABLENESS,
                    params: { year, month },
                };
            },
        }),
    }),
});

export const { useGetKronosTimeReasonablenessQuery } = timeCheckSlice;
